/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Tags_PlaceholderInputs */

const cs_form_tags_placeholder = /** @type {(inputs: Form_Tags_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napište štítek a stiskněte Enter`)
};

const en_form_tags_placeholder = /** @type {(inputs: Form_Tags_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type a tag and press Enter`)
};

/**
* | output |
* | --- |
* | "Type a tag and press Enter" |
*
* @param {Form_Tags_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_tags_placeholder = /** @type {((inputs?: Form_Tags_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Tags_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_tags_placeholder(inputs)
	return cs_form_tags_placeholder(inputs)
});